import _extends from "../../../../@babel/runtime/helpers/esm/extends.es.js";
import "react";
import { useGridRootProps } from "../../hooks/utils/useGridRootProps.es.js";
import { j as jsxRuntimeExports } from "../../../../react/jsx-runtime.es.js";
function GridFooterPlaceholder() {
  var _rootProps$slotProps;
  const rootProps = useGridRootProps();
  if (rootProps.hideFooter) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(rootProps.slots.footer, _extends({}, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.footer));
}
export {
  GridFooterPlaceholder
};
//# sourceMappingURL=GridFooterPlaceholder.es.js.map
